export const parseStatusSSEBlock = (block) => {
  let eventType = "";
  const dataLines = [];

  block.split("\n").forEach((line) => {
    if (line.startsWith("event:")) {
      eventType = line.slice(6).trim();
    } else if (line.startsWith("data:")) {
      dataLines.push(line.slice(5).trimStart());
    }
  });

  if (dataLines.length === 0) return null;

  const data = JSON.parse(dataLines.join("\n"));
  return {
    eventType: data?.template_name || eventType || "message",
    data,
  };
};

export const getCompletedStatusData = (eventType, data) => {
  if (eventType === "snapshot" && data?.status === "completed") {
    return {
      logId: data?.log_id,
      completeData: data,
    };
  }

  if (eventType === "completed") {
    return {
      logId: data?.log_id,
      completeData: data,
    };
  }

  if (eventType === "Query Complete") {
    return {
      logId:
        data?.data?.description?.log_id ||
        data?.description?.log_id ||
        data?.data?.log_id ||
        data?.log_id,
      completeData:
        data?.data?.description || data?.description || data?.data || data,
    };
  }

  if (!data?.template_name && data?.log_id && data?.question) {
    return {
      logId: data.log_id,
      completeData: data,
    };
  }

  return null;
};
